// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { Leads } from './Leads';

/**
 * UPS — a box containing the double conversion that defines it.
 *
 * A sine on the left and a square-ish step on the right: AC in, DC link, AC
 * out. The internal marks are the point. A plain labelled rectangle would be
 * indistinguishable from a PDU at chip size, and those two are the most common
 * pair on the drawing.
 */
export const UpsSymbol = ({ size = 18, leads }: SymbolGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <Leads top={6} bottom={18} leads={leads} />
    <rect
      x="3"
      y="6"
      width="18"
      height="12"
      rx="1"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE}
    />
    <path
      d="M5.8 13 q1.3 -3.4 2.6 0"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.3}
      strokeLinecap="round"
    />
    <line x1="12" y1="8" x2="12" y2="16" stroke="currentColor" strokeWidth={GLYPH_STROKE - 0.4} />
    <path
      d="M15 15 v-4 h3 v4"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.3}
      strokeLinejoin="round"
    />
  </svg>
);
